<template>
  <div class="pagination">
    <div class="d-flex flex-wrap align-center justify-center" style="gap: 0px 15px">
      <div class="per-page" v-if="totalPages > 1">
        <typography size="0.875rem">Select page</typography>
        <v-select
          :items="
            Array(totalPages)
              .fill(0)
              .map((_, i) => i + 1)
          "
          variant="plain"
          :model-value="currPage"
          @update:model-value="(val) => $emit('update:currPage', val)"
          class="custom-input"
          color="primary"
          density="compact"
        >
        </v-select>
      </div>
      <div class="per-page">
        <typography size="0.875rem">Rows per page</typography>
        <v-select
          :items="perPageArr || [10, 20, 50, 100, 200]"
          variant="plain"
          :model-value="perPage"
          @update:model-value="
            (val) => {
              $emit('update:perPage', val);
            }
          "
          class="custom-input"
          color="primary"
          density="compact"
        >
        </v-select>
      </div>
    </div>
    <div class="d-flex flex-wrap align-center justify-center" style="gap: 0px 15px">
      <typography size="0.875rem">{{ pageStatusText }}</typography>
      <div class="page-navigate">
        <v-btn
          variant="text"
          icon
          @click="$emit('pageDown')"
          :disabled="currPage <= 1"
          color="normal"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          variant="text"
          icon
          @click="$emit('pageUp')"
          :disabled="currPage >= totalPages"
          color="normal"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Typography from "./typography.vue";

const props = defineProps<{
  currPage: number;
  totalPages: number;
  perPage: number;
  pageStatusText: string;
  perPageArr?: number[];
}>();
const perPageArr = computed(() => props.perPageArr || [15, 20, 50, 100, 200]);

const emit = defineEmits<{
  (e: 'pageUp', ...args: any[]): void;
  (e: 'pageDown', ...args: any[]): void;
  (e: 'update:perPage', ...args: any[]): void;
  (e: 'update:currPage', ...args: any[]): void
}>();
emit("update:perPage", perPageArr.value[0]);
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.pagination {
  // width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0px 20px;
  align-items: center;
  justify-content: flex-end;
  padding: 2px 5px;
  flex-wrap: wrap;

  .per-page {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media screen and (max-width: 626px) {
    & {
      flex-direction: column;
      gap: 0px 15px;
    }
  }
}
</style>
